const styles = (theme) => ({
  root:{
    paddingTop:16,
    marginRight:16,
  },
  image:{
    width:160,
    height:160,
  }
})

export default styles